import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { useConfig } from "../../../hooks/use-config";
import { addFilesToProject, addInstructionToProject, deleteFileFromProject, fetchProjectFiles, fetchProjectFilesPayload, fetchProjects, projectQueryParams, ConvertedProjectResponse } from "../services/projects-services";
import { useToast } from "../../../hooks/use-toast";

export const useProjects = (queryParams: projectQueryParams) => {
    const { configurationSettings } = useConfig();
    return useQuery({
        queryKey: ["getProjects", queryParams],
        queryFn: () => fetchProjects(queryParams, configurationSettings),
    });
}



export const useAddFilesToProject = (projectId: string) => {
    const { configurationSettings } = useConfig();
    // const queryClient = useQueryClient();

    return useMutation({
        mutationKey: ["addFilesToProject", projectId],

        mutationFn: (file: File) =>
            addFilesToProject(configurationSettings, projectId, file),

        // onSuccess: () => {
        //     queryClient.invalidateQueries({
        //         queryKey: ["projectFiles", projectId],
        //     });
        // },
    });
};


export const useFetchProjectFiles = (payload: fetchProjectFilesPayload, options?: { enabled?: boolean }) => {
    const { configurationSettings } = useConfig();
    return useQuery({
        queryKey: ["projectFiles", payload.projectId, payload.page],
        queryFn: () => fetchProjectFiles(configurationSettings, payload),
        enabled: options?.enabled !== false,
    });
}

export const useDeleteFileFromProject = (projectId: string) => {
    const { configurationSettings } = useConfig();
    // const queryClient = useQueryClient();
    const { toast } = useToast();

    return useMutation({
        mutationKey: ["deleteFileFromProject", projectId],
        mutationFn: (fileIds: string[]) => deleteFileFromProject(configurationSettings, projectId, fileIds),
        onSuccess: () => {
            // queryClient.invalidateQueries({
            //     queryKey: ["projectFiles", projectId],
            // });
            toast({
                title: 'File deleted successfully',
                description: 'The file has been deleted from the project',
                variant: 'success',
            });
        },
    });
}



export const useAddInstructionToProject = (projectId: string) => {
    const { configurationSettings } = useConfig();
    const queryClient = useQueryClient();
    return useMutation<ConvertedProjectResponse, Error, string>({
        mutationKey: ["addInstructionToProject", projectId],
        mutationFn: (instruction: string) => addInstructionToProject(configurationSettings, projectId, instruction),
        onSuccess: () => {
            queryClient.invalidateQueries({
                queryKey: ["project", projectId],
            });
        },
    });
}
